/* @flow */

import * as React from 'react'

import { SessionContext } from '../../shared'
import { useTitle } from '../../hooks'
import { WebshopContext } from '../shared'

import WebshopDesignPageBodyRenderer from './WebshopDesignPageRenderer/WebshopDesignPageBodyRenderer'

const WebshopSplash = ({ webshopSplashDesignPage }) => {
  const { brand, updateWebshopSession, webshopSession, webshopSettings } =
    React.useContext(WebshopContext)

  useTitle(`${brand.name} B2B`)

  return (
    <WebshopDesignPageBodyRenderer
      brand={brand}
      gridItems={webshopSplashDesignPage?.grid_items || []}
    />
  )
}

export default WebshopSplash
